import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { StateService } from "src/app/_services/state.service";
import { RequestsService } from "src/app/_shared/services/requests.service";
import Swal from "sweetalert2";

const initialState = {
  referrers: [],
  commissionRate: 0,
  loaders: {},
  totalReferrers: 0,
  refferred: [],
  totalRefferred: 0,
  summary: {},
};
@Injectable({
  providedIn: "root",
})
export class ReferralService extends StateService<any> {
  referrals$: Observable<any> = this.select((state) => {
    return state;
  });

  referralsCommissionRate$: Observable<any> = this.select((state) => {
    return state.commissionRate;
  });
  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {
    super(initialState);

    const currentUser = this.authenticationService.getCurrentUserValue();
    const { country } = currentUser;
    this.getCommission();
  }

  loadReferrals(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    this.setState({ loaders: { ...this.state.loaders, referrers: true } });
    this.requestService
      .dashboard_fetch(`usage/referrals?${queryParams}`, params)
      .subscribe(
        (res: any) => {
          this.setState({
            referrers: res.data,
            totalReferrers: res.total,
            loaders: { ...this.state.loaders, referrers: false },
          });
          if (res.data.length === 0) {
            Swal.fire({
              title: "No referrals found for selected filters",
              type: "info",
              timer: 2000,
            });
          }
        },
        (error) => {
          this.setState({
            loaders: { ...this.state.loaders, referrers: false },
          });
          Swal.fire({
            title: "Loading referrals failed,try again later",
            type: "error",
            timer: 2000,
          });
        }
      );
  }
  getCommission() {
    this.setState({ loaders: { ...this.state.loaders, commission: true } });
    this.requestService.dash_get(`referrals/commission`, {}).subscribe(
      (res: Partial<{ data: { value: number } }>) => {
        this.setState({ commissionRate: res.data.value });
        this.setState({
          loaders: { ...this.state.loaders, commission: false },
        });
      },
      (error) => {
        this.setState({
          loaders: { ...this.state.loaders, commission: false },
        });
      }
    );
  }

  updateCommission(value) {
    this.setState({ loaders: { ...this.state.loaders, commission: true } });
    this.requestService
      .dash_post(`referrals/commission`, { rate: value })
      .subscribe(
        (res: Partial<{ data: { value: number } }>) => {
          this.setState({ commissionRate: res.data.value });
          this.setState({
            loaders: { ...this.state.loaders, commission: false },
          });
        },
        (error) => {
          this.setState({
            loaders: { ...this.state.loaders, commission: false },
          });
        }
      );
  }

  loadRefferred(id: string) {
    this.setState({
      refferred: [],
      loaders: { ...this.state.loaders, refferred: true },
    });
    this.requestService.dash_get(`referrals/${id}`, {}).subscribe(
      (res: Partial<{ data: any[] }>) => {
        this.setState({
          refferred: res.data,
          totalRefferred: res.data.length,
          loaders: { ...this.state.loaders, refferred: false },
        });
      },
      (error) => {
        this.setState({ loaders: { ...this.state.loaders, refferred: false } });
        Swal.fire({
          title: "Loading referrals failed,try again later",
          type: "error",
          timer: 2000,
        });
      }
    );
  }

  loadSummary(id: string) {
    this.setState({
      summary: {},
      loaders: { ...this.state.loaders, summary: true },
    });
    this.requestService.dash_get(`referrals?id=${id}`, {}).subscribe(
      (res: any) => {
        this.setState({
          summary: res.data.length > 0 ? res.data[0] : {},
          loaders: { ...this.state.loaders, summary: false },
        });
      },
      (error) => {
        this.setState({ loaders: { ...this.state.loaders, summary: false } });
      }
    );
  }
}
